import React, { Fragment, useContext, useEffect, useMemo } from "react";
import Page from "components/Page";
import { Col, Row } from "reactstrap";
import styles from "./StaffOfficeOptions.module.scss";
import timeSheetIcon from "assets/images/icTimeSheets.svg";
import contractsIcon from "assets/images/contracts.svg";
import accountIcon from "assets/images/accountadmin.svg";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import constants from "../../../constants";
import { motion } from "framer-motion";
import {
  useOfficeDetail,
  useStaffByUserId,
} from "repositories/office-repository";
import { useSelector } from "react-redux";
import performanceReviewIcon from "assets/images/performance_review.svg";
import { decodeId, setStorage } from "utils";
import { setOfficeNavigationContext } from "utils/officeNavigationContext";
import noticesIcon from "assets/images/notices.svg";
import DashboardIcon from "assets/images/Dashboard.svg";
import waitingListIcon from "assets/images/waiting_list.svg";
import PatientsIcon from "assets/images/patients.svg";
import SchedulerIcon from "assets/images/scheduler_new_icon.svg";
import TeamDashboardIcon from "assets/images/team_dashboard.svg";
import TaskIcon from "assets/images/task_management_card.svg";
import NotesIcon from "assets/images/notes_new.svg";
import PatientIcon from "assets/images/patient_chat_new.svg";
import MessageCenter from "assets/images/patient_message_center.svg";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import PolicyIcon from "assets/images/policy.svg";
import Info_book from "assets/images/info_book.svg";
import UpdateSubscriptionModel from "components/UpdateSubscriptionModel";
import { Store } from "containers/routes";
import { subscriptionReturnValues } from "reducers/Subscription";
import { usePatientAndTeamChatAccountAccess } from "repositories/family-member-repository";
let PageSize = 10;
function StaffOfficeOptions({ history, location, match, t }) {
  const goBack = () => history.push(constants.routes.accountOwner.offices);
  const profile = useSelector((state) => state.userProfile.profile);
  const { setIsSubscriptionModel } = useContext(Store);
  let { officeId } = useParams();
  const decodeOfficeId = parseInt(decodeId(officeId));
  const { isLoading, data } = useOfficeDetail(decodeId(match.params.officeId));
  const { data: checkData } = usePatientAndTeamChatAccountAccess(
    1,
    PageSize,
    data?.ownerId,
    { enabled: !!data?.ownerId },
  );
  const { data: staffDetail } = useStaffByUserId(decodeOfficeId, profile?.id);
  const subscriptionDetails = useSelector((prev) => prev.Subscription);

  const {
    isNoticiesFeatureEnabled,
    isTaskFeatureEnabled,
    isNotesAndReminderFeatureEnabled,
    isPerformanceReviewFeatureEnabled,
    isPatientConversationFeatureEnabled,
    isSchedulerFeatureEnabled,
    isTeamConversationFeatureEnabled,
    subscriptionPlanId,
  } = useMemo(
    () => subscriptionReturnValues(subscriptionDetails, data?.ownerId),
    [subscriptionDetails, data?.ownerId],
  );

  let officeName = null;

  if (
    location.state &&
    location.state.officeData &&
    location.state.officeData.officeName
  ) {
    officeName = location.state.officeData.officeName;
  }

  if (!isLoading && data) {
    officeName = data.name;
  }

  useEffect(() => {
    setStorage(constants.notes.cache.isChatFromDashBoard, false);
    setStorage(constants.notes.cache.isFromStaffAdmin, true);
    setStorage("is-from-appointment-dashboard", false);
    setStorage("isFromPatientAppointment", false);
    setStorage("isFromPatientChat", false);
  }, []);

  const handleRedirect = (officeId) => {
    history.push({
      pathname: constants.routes.appointment.appointmentScreen,
      state: {
        officeId: officeId,
        activetabs: 1,
        statusFilter: [],
        isfromPaitentDetail: true,
      },
    });
  };

  const handlePatientRedirect = (officeId) => {
    history.push(
      constants.routes.appointment.patients.replace(":officeId", officeId),
    );
    setStorage("officeState", {
      officeState: {},
    });
    setStorage("patient_from_admin", 2);
  };

  useEffect(() => {
    setOfficeNavigationContext({
      officeSlection: false,
      staffOfficeSlection: true,
      isAdminControl: false,
      officeId: data?.id,
      officeName: data?.name,
      ownerId: data?.ownerId ?? null,
    });
  }, [data]);

  const chatAcess =
    Array.isArray(checkData) && checkData.length === 1 ? checkData[0] : null;

  const shouldShowTitle =
    staffDetail?.isDoctor ||
    staffDetail?.isReceptionist ||
    chatAcess?.isPatientChat;

  return (
    <>
      <Page
        onBack={goBack}
        isTitleLoading={!officeName && isLoading}
        title={officeName || (data && data.name)}
        className={styles["page"]}
      >
        <>
          {/* Office Category */}
          <div className="margin30">
            <p className={styles["mobile-text-size"]}>{t("officeCategory")}</p>
            <Row>
              {profile && staffDetail?.isAdmin && (
                <Col lg="4">
                  <Card
                    to={constants.routes.staff.officeAdmin.replace(
                      ":officeId",
                      match.params.officeId,
                    )}
                    icon={accountIcon}
                    title={t("adminControls")}
                    data={location.state}
                  />
                </Col>
              )}
              <Col lg="4">
                <Card
                  to={constants.routes.scheduler.calendar}
                  icon={SchedulerIcon}
                  title={t("navbar.scheduler")}
                  officeName={officeName}
                  isDisabled={!isSchedulerFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              {!staffDetail?.isAdmin &&
                (staffDetail?.isDoctor || staffDetail?.isReceptionist) && (
                  <Col lg="4">
                    <Card
                      to={constants.routes.accountOwner.timelinePreferences.replace(
                        ":officeId",
                        match.params.officeId,
                      )}
                      icon={timeSheetIcon}
                      title={t("accountOwner.Mypreferences")}
                      officeName={location.state}
                      data={{ officeName: data?.name }}
                    />
                  </Col>
                )}
              <Col lg="4">
                <Card
                  to={
                    constants.routes.officePolicyManagements
                      .officePolicyManagement
                  }
                  icon={PolicyIcon}
                  isDisabled={!isTaskFeatureEnabled}
                  title={t("navbar.policyManagement")}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.officeStaffInformation.replace(
                    ":officeId",
                    match.params.officeId,
                  )}
                  data={{
                    officeName: data?.name,
                    officeImage: data?.officeImage,
                    address: data?.address,
                    contactNumber: data?.contactNumber,
                  }}
                  icon={Info_book}
                  title={t("accountOwner.officeStaffInformation")}
                />
              </Col>
            </Row>
          </div>
          <div className="margin30">
            <p className={styles["mobile-text-size"]}>{t("Team")}</p>
            <Row>
              <Col lg="4">
                <Card
                  to={constants.routes.dashboard.managerDashboard}
                  icon={TeamDashboardIcon}
                  title={t("dashBoard.teamDashboard")}
                  officeName={officeName}
                />
              </Col>
              {chatAcess?.isMessenger && (
                <Col lg="4">
                  <Card
                    to={constants.routes.chatModule}
                    icon={MessageCenter}
                    title={t("messenger.teamConversation")}
                    isDisabled={!isTeamConversationFeatureEnabled}
                    setIsSubscriptionModel={setIsSubscriptionModel}
                  />
                </Col>
              )}
              <Col lg="4">
                <Card
                  to={constants.routes.taskManagements.taskManagement}
                  icon={TaskIcon}
                  title={t("navbar.taskManagement")}
                  isDisabled={!isTaskFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.notes}
                  icon={NotesIcon}
                  title={t("Notes & Reminder")}
                  isDisabled={!isNotesAndReminderFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
            </Row>
          </div>

          {/* My Records */}
          <div>
            <p className={styles["mobile-text-size"] + " " + "margin30"}>
              {t("myRecordsCategory")}
            </p>
            <Row>
              <Col lg="4">
                {" "}
                <Card
                  to={constants.routes.staff.timesheet.replace(
                    ":officeId",
                    match.params.officeId,
                  )}
                  icon={timeSheetIcon}
                  title={t("staff.myTimesheetsLeaves")}
                  data={location.state}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.myPerformanceReview.replace(
                    ":officeId",
                    match.params.officeId,
                  )}
                  icon={performanceReviewIcon}
                  title={t("staff.myPerformanceReview")}
                  data={location.state}
                  isDisabled={!isPerformanceReviewFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              <Col lg="4">
                <Card
                  to={constants.routes.accountOwner.myNotices.replace(
                    ":officeId",
                    match.params.officeId,
                  )}
                  icon={noticesIcon}
                  title={t("notices.myPerformanceNotoces")}
                  data={location.state}
                  isDisabled={!isNoticiesFeatureEnabled}
                  setIsSubscriptionModel={setIsSubscriptionModel}
                />
              </Col>
              {data && !data.isTempOffice && (
                <Col lg="4">
                  <Card
                    to={constants.routes.accountOwner.myForms.replace(
                      ":officeId",
                      match.params.officeId,
                    )}
                    icon={contractsIcon}
                    title={t("contracts.formsAndContract")}
                    data={location.state}
                  />
                </Col>
              )}
            </Row>
          </div>

          {/* Patient Management */}
          <div>
            {shouldShowTitle && (
              <p className={`${styles["mobile-text-size"]} margin30`}>
                {t("pateintManagementCategory")}
              </p>
            )}
            <Row>
              {(staffDetail?.isDoctor || staffDetail?.isReceptionist) && (
                <Col lg="4">
                  <Card
                    to={constants.routes.superAdmin.appointmentDashboard.replace(
                      ":officeId",
                      match.params.officeId,
                    )}
                    icon={DashboardIcon}
                    title="Patient Dashboard"
                  />
                </Col>
              )}
              {(staffDetail?.isDoctor || staffDetail?.isReceptionist) && (
                <Col lg="4">
                  <Card
                    redirectTo={() =>
                      handlePatientRedirect(match.params.officeId)
                    }
                    icon={PatientsIcon}
                    title={t("patients.patients")}
                  />
                </Col>
              )}
              {(staffDetail?.isDoctor || staffDetail?.isReceptionist) && (
                <Fragment>
                  <Col lg="4">
                    <Card
                      to={constants.routes.waitingList.replace(
                        ":officeId",
                        match.params.officeId,
                      )}
                      icon={waitingListIcon}
                      title={t("waitingList.waitingList")}
                    />
                  </Col>
                </Fragment>
              )}
              {staffDetail?.isReceptionist && (
                <Col lg="4">
                  <Card
                    redirectTo={() =>
                      handleRedirect(decodeId(match.params.officeId))
                    }
                    icon={DashboardIcon}
                    title="Receptionist"
                  />
                </Col>
              )}
              {chatAcess?.isPatientChat && (
                <Col lg="4">
                  <Card
                    to={constants.routes.patientChatModule}
                    icon={PatientIcon}
                    title={t("dashBoard.patientChat")}
                    isDisabled={!isPatientConversationFeatureEnabled}
                    setIsSubscriptionModel={setIsSubscriptionModel}
                  />
                </Col>
              )}
            </Row>
          </div>
        </>
      </Page>
      <UpdateSubscriptionModel
        t={t}
        isFromOfficeOptions={true}
        plan={subscriptionPlanId}
      />
    </>
  );
}

function Card({
  to,
  icon,
  title,
  data,
  redirectTo,
  isDisabled = false,
  setIsSubscriptionModel = () => {},
}) {
  if (redirectTo) {
    return (
      <motion.div
        whileHover={{ scale: constants.animation.hoverScale }}
        whileTap={{ scale: constants.animation.hoverScale }}
      >
        <span
          onClick={isDisabled ? () => {} : redirectTo}
          className={isDisabled ? "disabled" : "pointer"}
        >
          <div className={styles["card"]}>
            <img className={`${styles["icon"]} mr-2`} src={icon} alt="icon" />
            <h4>{title}</h4>
          </div>
        </span>
      </motion.div>
    );
  }
  return (
    <motion.div
      whileHover={{ scale: constants.animation.hoverScale }}
      whileTap={{ scale: constants.animation.hoverScale }}
    >
      <Link
        to={isDisabled ? "#" : { pathname: to, state: data }}
        onClick={(e) => {
          if (isDisabled) {
            e.preventDefault();
            setIsSubscriptionModel(true);
          }
        }}
      >
        <div
          className={`${styles["card"]} ${
            isDisabled ? styles["disabled"] : ""
          }`}
        >
          <img className={`${styles["icon"]} mr-2`} src={icon} alt="icon" />
          <h4>{title}</h4>
        </div>
      </Link>
    </motion.div>
  );
}

export default withTranslation()(StaffOfficeOptions);
